import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "services/common"

interface UpdateBookingReviewResponseData extends ResponseData {
  data: string
}

interface UpdateBookingReviewResponse extends AxiosResponse {
  data: UpdateBookingReviewResponseData
}

export interface UpdateBookingReviewRequest
  extends Partial<AxiosRequestConfig> {
  data: {
    propertyId: string
    bookingReview: boolean
  }
}

export function updateBookingReviewApi(
  { data, ...config }: UpdateBookingReviewRequest,
  axiosInstance: AxiosInstance,
): Promise<UpdateBookingReviewResponse> {
  return axiosInstance({
    method: "put",
    data,
    url: `newadmin/property/booking-review`,
    ...config,
  })
}
